// @flow

import type { StaticHandlerArgs } from '@gandi/app-runner/server';
import { selectIsAuthenticatedUser } from '@gandi/authentication';

import type { FullState } from '../../types';

export type Params = {
  cartId?: string,
  ...
};

export default function setPublicHTTPCache(
  args: StaticHandlerArgs<{}, Params, empty, FullState>,
) {
  // Leverage webacc HTTP cache - no browser cache -
  // for bare, unauthenticated version of /{locale}/domain/suggest
  const { req, params, res, getState } = args;
  const authenticated = selectIsAuthenticatedUser(getState());
  if (!authenticated && !params.cartId) {
    // max-age=1: cache for 1second in the browser
    //    should anonymous user fetch this, then auth, browser cache should
    //    not be used anymore.
    //    We do not trust max-age=0 to have a reliable behavior across browser
    //    vendor, one second is good enough, and show similar results
    // s-max-age=600: cache for 10minutes in proxies
    // stale-if-error=3600: serve cached response from proxy,
    //    while backend is broken.
    // In case of emergency: curl -X PURGEALL https://shop.gandi.net
    // Use `X-Cache-Control-After-Gzip` to set `Cache-Control` after gzip.
    res.header(
      'X-Cache-Control-After-Gzip',
      'max-age=1, s-maxage=600, stale-if-error=3600, public, no-transform',
    );
    res.append('Vary', 'DNT, Accept-Encoding, Cookie');
    if (!req.query.country) {
      res.append('Vary', 'X-Country-Code');
    }
  }
}
